import React from 'react';
import { Tooltip } from 'antd';
import Icon from '@mdi/react';
import { mdiHelpCircleOutline } from '@mdi/js';
import PropTypes from 'prop-types';

const NameDefinition = ({
  name,
  definition,
  placement = 'bottom',
  size = 0.6,
  textSize = 'text-xs',
}) => {
  return (
    <Tooltip
      title={<div className='max-w-96 !text-sm !font-normal'>{definition}</div>}
      placement={placement}
      className={`flex items-center w-fit gap-1 cursor-pointer font-semibold ${textSize}`}
    >
      {name && <span>{name}</span>}
      <Icon path={mdiHelpCircleOutline} size={size} />
    </Tooltip>
  );
};

export default NameDefinition;

NameDefinition.propTypes = {
  name: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired,
  placement: PropTypes.string,
  size: PropTypes.number,
  textSize: PropTypes.string,
};
